import api from '.';
import { PaginationProps } from '../common/interface/pagination';

interface GetWorkflowParams extends PaginationProps {}

interface CreateWorkflow {
  name: string;
  workflowStepIds: number[];
}

interface UpdateWorkflow extends CreateWorkflow {
  id: number | null;
}

export async function getWorkflows() {
  const { data } = await api.get('/workflows');
  return data;
}

export async function getWorkflowsMasterData(params: GetWorkflowParams) {
  const { data } = await api.get('/workflows/master-data', {
    params
  });
  return data;
}

export async function getWorkflow(id: number) {
  const { data } = await api.get(`/workflows/${id}`);
  return data;
}

export async function createWorkflow(createWorkflow: CreateWorkflow) {
  const { data } = await api.post('/workflows', createWorkflow);
  return data;
}

export async function updateWorkflow(updateWorkflow: UpdateWorkflow) {
  const { data } = await api.put(
    `/workflows/${updateWorkflow.id}`,
    updateWorkflow
  );
  return data;
}

export function deleteWorkflow(id: number) {
  return api.delete(`/workflows/${id}`);
}
